import React from 'react';
import MyTicketsContainer from "@MyTickets/components/MyTicketsContainer";

function MyTicketsOutlet() {
    return (
        <MyTicketsContainer/>
    );
}

export default MyTicketsOutlet;